import { observarCarregamento } from './carregamentoGlobal';
import { getUserCachedData } from "./UserAuthorization";
import axios from 'axios';
import { config } from '../config/environment';

export const getAuthHeaders = () => {
  const token = getUserCachedData()?.token;

  return {
    Authorization: `Bearer ${token}`
  };
};

export const request = axios.create({
  baseURL: config.BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

observarCarregamento(request);

// Interceptor para adicionar o token automaticamente
request.interceptors.request.use((config) => {
  const authHeaders = getAuthHeaders();
  if (authHeaders.Authorization) {
    config.headers.Authorization = authHeaders.Authorization;
  }
  return config;
});
